import { useSettings } from '../../hooks/queries'
import { useTexte } from '../../texte'
import { Stand } from './DiensteCard'

/**
 * Ob GIFs in Antworten zur Verfügung stehen — und was zu tun ist, wenn nicht.
 *
 * **Der Grund für diese Karte ist eine Meldung aus dem Betrieb:** „kein Knopf
 * um GIFs hochzuladen". Ohne `GIPHY_API_KEY` steht in der Eingabezeile
 * nichts, und das ist so gewollt — aber wer es nicht weiß, sucht einen Knopf,
 * den es nicht gibt. Ein abgeschalteter Dienst muss sagen, dass er
 * abgeschaltet ist; sonst sieht Absicht aus wie ein Fehler.
 *
 * Sie steht neben „Ort und Wetter" und nicht darin: das ist ein anderer
 * Dienst mit einem anderen Schlüssel.
 */
export function GifCard() {
  const t = useTexte()
  const settings = useSettings()
  const daten = settings.data

  // Ohne Decke ist dieses Konto keine Verwaltung -- der Server hat entschieden.
  if (!daten?.ceiling) return null

  const an = daten.services?.gif === true

  return (
    <div className="card card--seite">
      <h2 className="card__titel">{t.gif.titel}</h2>
      <p className="card__lead" style={{ marginBottom: 10 }}>{t.gif.lead}</p>

      <p className="dienst">
        <span className="dienst__name">{t.gif.name}</span>
        <Stand an={an} />
      </p>

      {an ? (
        <p className="card__lead" style={{ marginTop: 10, marginBottom: 0 }}>
          {t.gif.an}
        </p>
      ) : (
        <>
          <p className="card__lead" style={{ marginTop: 10, marginBottom: 0 }}>
            {t.gif.aus}
          </p>
          <ul className="dienst__zeilen">
            <li>GIPHY_API_KEY</li>
          </ul>
        </>
      )}
    </div>
  )
}
